import styled from "styled-components";

export const _SummaryViewHeadingContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const _SummaryViewArticlesContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
